import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { createEntitySlice, EntityState } from 'app/shared/reducers/reducer.utils';
import { IKpiPresetWeightVehicle } from 'app/shared/model/kpi-preset-weight-vehicle.model';
import { IKpiConfWeight } from 'app/shared/model/kpi-conf-weight.model';

export interface IKpiPresetWeightVehicleState extends EntityState<IKpiPresetWeightVehicle> {
  loading: boolean;
  errorMessage: string | null;
  kpiConfs: IKpiConfWeight[];
  kpiVehicles: IKpiPresetWeightVehicle[];
  updating: boolean;
  updateSuccess: boolean;
}

const initialState: IKpiPresetWeightVehicleState = {
  loading: false,
  errorMessage: null,
  kpiConfs: [],
  kpiVehicles: [],
  updating: false,
  updateSuccess: false,
  entities: [],
  entity: {} as IKpiPresetWeightVehicle,
  totalItems: 0,
};

const apiUrl = 'api/kpi-preset-weight-data';

export const updateEntities = createAsyncThunk(
  'preset_weight/update_entities',
  async (payload: { kpiConfs: IKpiConfWeight[]; kpiVehicles: IKpiPresetWeightVehicle[] }) => {
    const response = await axios.put(`${apiUrl}/batch-update`, {
      kpiConfs: payload.kpiConfs,
      kpiVehicles: payload.kpiVehicles,
    });
    return response;
  }
);

export const restoreDefault = createAsyncThunk('preset_weight/restore_default', async (payload: { presetId: number; companyId: number | null }) => {
  const { presetId, companyId } = payload;

  let requestUrl = `${apiUrl}/restore-default/${presetId}`;

  if (companyId !== null && companyId !== undefined) {
    requestUrl += `?companyId=${companyId}`;
  }

  const response = await axios.post<{ kpiConfs: IKpiConfWeight[]; kpiVehicles: IKpiPresetWeightVehicle[] }>(requestUrl);
  return response;
});

export const PresetWeightSlice = createEntitySlice({
  name: 'presetWeight',
  initialState,
  reducers: {
    reset(state) {
      const s = state as unknown as IKpiPresetWeightVehicleState;
      s.kpiConfs = [];
      s.kpiVehicles = [];
      s.loading = false;
      s.updating = false;
      s.updateSuccess = false;
      s.errorMessage = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(updateEntities.pending, state => {
        const s = state as unknown as IKpiPresetWeightVehicleState;
        s.loading = true;
        s.updating = true;
        s.errorMessage = null;
        s.updateSuccess = false;
      })
      .addCase(updateEntities.fulfilled, (state, action) => {
        const s = state as unknown as IKpiPresetWeightVehicleState;
        s.loading = false;
        s.updating = false;
        s.updateSuccess = true;
        s.kpiConfs = action.payload.data.kpiConfs ?? [];
        s.kpiVehicles = action.payload.data.kpiVehicles ?? [];
        s.errorMessage = null;
      })
      .addCase(updateEntities.rejected, (state, action) => {
        const s = state as unknown as IKpiPresetWeightVehicleState;
        s.loading = false;
        s.updating = false;
        s.errorMessage = action.error.message ?? 'Erro ao salvar alterações';
      })
      .addCase(restoreDefault.pending, state => {
        const s = state as unknown as IKpiPresetWeightVehicleState;
        s.errorMessage = null;
        s.updateSuccess = false;
        s.updating = true;
      })
      .addCase(restoreDefault.fulfilled, (state, action) => {
        const s = state as unknown as IKpiPresetWeightVehicleState;
        s.updating = false;
        s.loading = false;
        s.updateSuccess = true;
        s.kpiConfs = action.payload.data.kpiConfs ?? [];
        s.kpiVehicles = action.payload.data.kpiVehicles ?? [];
        s.errorMessage = null;
      })
      .addCase(restoreDefault.rejected, (state, action) => {
        const s = state as unknown as IKpiPresetWeightVehicleState;
        s.loading = false;
        s.updating = false;
        s.errorMessage = action.error.message ?? 'Erro ao restaurar valores';
      });
  },
});

export const { reset } = PresetWeightSlice.actions;
export default PresetWeightSlice.reducer;
